<template>
  <div class="page_bg" @click="closeBox">
    <div class="main_box">
      <!-- 顶部导航栏 -->
      <div class="back_box">
        <div class="back_left">
          <div class="back_btn" @click="backPage">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
          <div class="page_title">
            <span class="class_name">{{ className }}</span>
            <span class="title_sep">/</span>
            单科练习
          </div>
        </div>
        <div class="top_right">
          <div class="btn btn_list" @click.stop.prevent="openList1">
            <div>科目：{{ m_subList[m_subjectIndex] && m_subList[m_subjectIndex].sub.sub_name }}</div>
            <img src="../../img/change.png" alt="">
            <div class="right_fix_box" :class="[isListOpen1 == false ? 'right_fix_box_close' : '']">
              <div class="fix_title">科目列表：</div>
              <div class="subject_item" v-for="(item, index) in m_subList" :key="index"
                :class="[index == m_subjectIndex ? 'subject_item_select' : '']"
                @click.stop.prevent="subjectChange(index,item.pro_sub_id)">{{ item.sub.sub_name }}</div>
            </div>
          </div>
          <div class="btn btn_list" @click.stop.prevent="openList2">
            <div>模式：{{ patternType[patternTypeIndex].text }}</div>
            <img src="../../img/change.png" alt="">
            <div class="right_fix_box" :class="[isListOpen2 == false ? 'right_fix_box_close' : '']">
              <div class="fix_title">练习模式：</div>
              <div class="subject_item" v-for="(item, index) in patternType" :key="index"
                :class="[index == patternTypeIndex ? 'subject_item_select' : '']"
                @click.stop.prevent="patternTypeChange(index, item.type)">{{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_area">
        <div class="row_2">
          <div class="left">
            <div class="qtklx">
              <div class="title_box">
                <div class="title">全题库训练</div>
                <div class="jump_box">
                  <el-input class="sb_number" placeholder="输入题号（非必填）" min="1" v-model="inputInfo" clearable
                    size="small">
                  </el-input>
                  <div class="btn start_btn" @click="m_startQuanTiKu(inputInfo)">开始训练</div>
                </div>
              </div>
              <div class="progress_box">
                <div class="text_box">
                  <div>{{m_process.current}}/{{m_process.total}}</div>
                  <div>答题进度</div>
                </div>
                <el-progress :percentage="m_process.percentage" class="progress" :show-text="false" :stroke-width="10" color="#646eff"
                  define-back-color="#cdd8fd"></el-progress>
              </div>
            </div>
            <div class="select_box">
              <div class="more_box">
                <div class="point_box" @click.stop.prevent="openMoreBox">
                  <div class="point"></div>
                  <div class="point"></div>
                  <div class="point"></div>
                </div>
                <div class="more_list" :class="[isOpenMore == false ? 'more_list_close' : '']">
                  <div class="more_item" @click.stop.prevent="m_showClearCuoTiModal">清除错题</div>
                  <div class="more_item" @click.stop.prevent="m_showClearShouCangModal">清除收藏</div>
                </div>
              </div>
              <div class="wrong_collect_btn" @click="m_startCuoTiZhuanKao">
                <img src="../../img/dklx_wrong.png" alt="">
                <div class="text">我的错题</div>
              </div>
              <div class="wrong_collect_btn" @click="m_startShouCangZhuanKao">
                <img src="../../img/dklx_collect.png" alt="">
                <div class="text">我的收藏</div>
              </div>
              <div class="wrong_collect_btn">
                <img src="../../img/dklx_bjb.png" alt="">
                <div class="text">笔记本</div>
              </div>
              <div class="wrong_collect_btn">
                <img src="../../img/dklx_mncs.png" alt="">
                <div class="text">模拟测试</div>
              </div>
              <div class="wrong_collect_btn">
                <img src="../../img/dklx_wdsj.png" alt="">
                <div class="text">我的试卷</div>
              </div>
            </div>
          </div>
          <div class="middle">
            <div class="zjlx" @click="openTreeShade">
              <img src="../../img/zjlx.png" alt="">
              <div class="text1">章节练习</div>
              <div class="text2">系统性练习知识点</div>
              <div class="text3">马上进入>></div>
            </div>
            <div class="txlx">
              <div class="title">题型练习</div>
              <div class="select_box">
                <div :class="{disable:!m_quesTypeList.find(item=>item.ques_type == m_QuestType.SingleChoise)}" class="subject_type_btn"
                  @click="!m_quesTypeList.find(item=>item.ques_type == m_QuestType.SingleChoise) ? null : m_startTiXingZhuanKao(m_QuestType.SingleChoise)">
                  <img src="../../img/txlx_danxuanti.png" alt="">
                  <div class="text">单选题</div>
                </div>
                <div :class="{disable:!m_quesTypeList.find(item=>item.ques_type == m_QuestType.MultipleChoise)}"
                  class="subject_type_btn"
                  @click="!m_quesTypeList.find(item=>item.ques_type == m_QuestType.MultipleChoise) ? null : m_startTiXingZhuanKao(m_QuestType.MultipleChoise)">
                  <img src="../../img/txlx_duoxuanti.png" alt="">
                  <div class="text">多选题</div>
                </div>
                <div :class="{disable:!m_quesTypeList.find(item=>item.ques_type == m_QuestType.Judge)}" class="subject_type_btn"
                  @click="!m_quesTypeList.find(item=>item.ques_type == m_QuestType.Judge) ? null : m_startTiXingZhuanKao(m_QuestType.Judge)">
                  <img src="../../img/txlx_panduantiti.png" alt="">
                  <div class="text">判断题</div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="title">数据分析</div>
            <div class="data_box">
              <div>
                <div class="data_item">
                  <div>
                    <span class="text1">{{m_analysis.new_mark}}</span>
                    <span class="text2">分钟</span>
                  </div>
                  <div class="text3">今日已学</div>
                </div>
                <div class="data_item">
                  <div>
                    <span class="text1">{{m_analysis.new_rate}}</span>
                    <span class="text2">%</span>
                    <img src="../../img/jt_1.png" alt="">
                  </div>
                  <div class="text3">今日正确率</div>
                </div>
              </div>
              <div>
                <div class="data_item">
                  <div>
                    <span class="text1">{{m_analysis.tire_mark}}</span>
                    <span class="text2">分钟</span>
                  </div>
                  <div class="text3">累计已学</div>
                </div>

                <div class="data_item">
                  <div>
                    <span class="text1">{{m_analysis.top_score}}</span>
                    <span class="text2">分</span>
                  </div>
                  <div class="text3">模拟最高分</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row_3">
          <div class="title">实用工具</div>
          <div class="tool_box">
            <div class="tool_item"></div>
            <div class="tool_item"></div>
          </div>
        </div>
      </div>
    </div>

    <comfirm @clickCancel="cancel" @clickComfirm="comfirm" :data="comfirmData" v-if="isShadeShow"></comfirm>
    <comfirm @clickCancel="cancel2" @clickComfirm="comfirm2" :data="comfirmData2" v-if="isShadeShow2"></comfirm>
    <div class="shadeBox" v-if="isShadeShow3" @click.stop.prevent="closeTreeShade">
      <div class="zhangjie_box">
        <div class="title">
          <div>章节列表</div>
          <img src="../../img/close.png" alt="" @click="closeTreeShade">
        </div>
        <div class="tree_box">
          <el-tree :data="m_unitList" accordion :props="unitListDefaultProps" @node-click="handleNodeClick">
            <span class="tree_other_box" slot-scope="{ node, data }">
              <span>{{ data.unit_name }}</span>
              <div class="info_box">
                <div class="status_btn">{{data.is_then ? '正在进行' : ''}}</div>
                <div class="count_box">{{data.count_sum}}/{{data.ques_num}}</div>
                <div class="start_btn btn" @click.stop.prevent="m_startZhangJieLianXi(data)">开始练习
                  <img src="../../img/jt_3.png" alt="">
                </div>
                <!-- <el-button type="text" size="mini" @click.stop.prevent="() => append(data)">
                                    Append
                                </el-button>
                                <el-button type="text" size="mini" @click="() => remove(node, data)">
                                    Delete
                                </el-button> -->
              </div>
            </span>
          </el-tree>

        </div>
      </div>
    </div>
    <div class="page_end_fixed">
      <endBox></endBox>
    </div>

    <comfirm @clickCancel="clearCancel" @clickComfirm="clearComfirm" :data="clearConfirmModalData"
      v-if="isShowClearConfirmModal"></comfirm>
    <comfirm2 :top="130"  @clickComfirm="cantExerciseComfirm" :data="ce_cantExerciseComfirmData" v-if="ce_isShowCantExerciseModal"></comfirm2>
  </div>
</template>

<script>
  import comfirm from "../../components/comfirm.vue"
  import comfirm2 from "../../components/comfirm2.vue"
  import * as exerciseApi from '@/api/exercise.js';
  import exerciseHomeMixin from '@/mixins/exercise-home.js';
  import cantExerciseMixin from '@/mixins/cant-exercise.js';

  import {
    Loading,
    Message
  } from 'element-ui';

  export default {
    mixins: [exerciseHomeMixin, cantExerciseMixin],
    components: {
      comfirm,
      comfirm2
    },
    created() {
      this.m_init();
      this.className = window.localStorage.getItem("className") || "";
    },

    mounted() {},
    data() {
      return {
        className: "",
        unitListDefaultProps: {
          children: 'son_arr',
          label: 'unit_name'
        },
        isShadeShow: false,
        comfirmData: {
          title: "确认清除收藏",
          img: "https://resources.sxsaas.com/static/jigou-saas-app/comfrim_1.png",
          info: "确认要清除收藏吗？"
        },

        isShadeShow2: false,
        comfirmData2: {
          title: "确认清除错题",
          img: "https://resources.sxsaas.com/static/jigou-saas-app/comfrim_1.png",
          info: "确认要清除错题吗？"
        },

        isShadeShow3: false,
        isListOpen1: false,
        shadeBoxinputInfo: "",
        inputInfo:"",


        isListOpen2: false,
        patternTypeIndex: 0,
        patternType: [
          {
            type:2,
            text:'练题模式'
          },
          {
            type:3,
            text:'测题模式'
          }
        ],



        isOpenMore: false,


        isShowClearConfirmModal: false,
        clearConfirmModalData: {
          // title: "确认清空答题记录",
          img: "https://resources.sxsaas.com/static/jigou-saas-app/comfrim_1.png",
          // info: "确认清空答题记录吗？",
          // data: {},
        },
      };
    },
    methods: {
      backPage() {
        this.$router.push({ name: 'ExamTab' });
      },
      openMoreBox() {
        this.isOpenMore = this.isOpenMore == true ? false : true
      },
      selectMore(index) {
        this.isOpenMore = false
        switch (parseInt(index)) {
          case 1:
            this.isShadeShow2 = true
            break;
          case 2:
            this.isShadeShow = true
            break;
          default:
            break;
        }
      },
      openList1() {
        this.isListOpen2 = false
        this.isListOpen1 = this.isListOpen1 == true ? false : true

      },
      subjectChange(index, pro_sub_id) {
        this.subjectIndex = parseInt(index)
        this.isListOpen1 = false
        this.m_subjectChange(pro_sub_id);
      },
      closeBox(){
        console.log(123);
        this.isListOpen1 = false;
        this.isListOpen2 = false;
        this.isOpenMore = false
      },

      openList2() {
        this.isListOpen1 = false
        this.isListOpen2 = this.isListOpen2 == true ? false : true

      },
      patternTypeChange(index,type) {
        this.patternTypeIndex = parseInt(index)
        this.m_pattern_type = type;
        this.isListOpen2 = false
      },
      cancel(value) {
        console.log(value);
        this.isShadeShow = false
      },
      comfirm(value) {
        console.log(value);
        this.isShadeShow = false
      },
      cancel2(value) {
        console.log(value);
        this.isShadeShow2 = false
      },
      comfirm2(value) {
        console.log(value);
        this.isShadeShow2 = false
      },
      handleNodeClick(data) {
        console.log(data);
      },
      openTreeShade() {
        // 获取章节
        this.m_requestUnits();
      },
      closeTreeShade() {
        this.isShadeShow3 = false;
      },
      append(data) {
        console.log(data);
      },
      clearComfirm() {
        this.clearConfirmModalData.confirm().then(res=>{

        }).finally(()=>{
          this.clearCancel();
        });
      },
      clearCancel() {
        this.isShowClearConfirmModal = false;
        this.clearConfirmModalData = {
          img: this.clearConfirmModalData.img
        };
      },
      cantExerciseComfirm() {
        this.$router.back()
      },
    },
  };
</script>
<style scoped>
/* ========== 页面背景 ========== */
.page_bg {
  background: #f5f7fa;
  width: 100%;
  min-height: 100vh;
  overflow-y: auto;
}

.main_box {
  width: 1160px;
  margin: 0 auto;
  padding-bottom: 80px;
}

/* ========== 顶部导航 ========== */
.back_box {
  width: 100%;
  max-width: 1160px;
  height: 56px;
  background: #fff;
  margin: 20px auto 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 24px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 9;
}

.back_left {
  display: flex;
  align-items: center;
  gap: 18px;
}

.back_btn {
  height: 34px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: #f0f2ff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #646eff;
  font-weight: 500;
  transition: all 0.2s;
}

.back_btn:hover {
  background: #e4e7ff;
}

.back_btn i {
  font-size: 13px;
}

.page_title {
  color: #1a1a2e;
  font-weight: 700;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.class_name {
  color: #646eff;
  font-weight: 600;
}

.title_sep {
  color: #dcdfe6;
  font-weight: 400;
}

/* 顶部右侧选择器 */
.top_right {
  display: flex;
  gap: 10px;
}

.top_right .btn_list {
  position: relative;
}

.top_right .btn {
  height: 34px;
  padding: 0 14px;
  background: #f7f8fa;
  color: #606266;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
  border: 1px solid #ebeef5;
}

.top_right .btn:hover {
  background: #eef0ff;
  border-color: rgba(100, 110, 255, 0.2);
}

.top_right .btn img {
  width: 14px;
  height: 14px;
  margin: 0;
}

/* 下拉面板 */
.right_fix_box {
  width: 280px;
  max-height: 360px;
  background: #fff;
  position: absolute;
  z-index: 9;
  right: 0;
  top: 40px;
  border-radius: 8px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
  border: 1px solid #ebeef5;
  transition: all 0.2s ease;
  overflow-y: auto;
  box-sizing: border-box;
}

.right_fix_box .fix_title {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  box-sizing: border-box;
  padding: 10px 16px;
  border-bottom: 1px solid #f0f2f5;
  color: #1a1a2e;
}

.right_fix_box_close {
  height: 0 !important;
  padding: 0;
  overflow: hidden;
  border: none;
  box-shadow: none;
}

.subject_item {
  width: 100%;
  height: 38px;
  box-sizing: border-box;
  padding: 0 16px;
  display: flex;
  align-items: center;
  border-top: 1px solid #f5f5f5;
  cursor: pointer;
  font-size: 13px;
  color: #606266;
  transition: all 0.15s;
}

.subject_item_select {
  background: #646eff;
  color: #fff;
}

.subject_item:hover {
  background: #eef0ff;
  color: #646eff;
}

.subject_item_select:hover {
  background: #5560e8;
  color: #fff;
}

/* ========== 内容区域 ========== */
.content_area {
  width: 100%;
  padding-top: 4px;
}

/* ========== 第一行三栏布局 ========== */
.row_2 {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

/* --- 左侧：全题库训练 + 快捷入口 --- */
.row_2 .left {
  width: 592px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.row_2 .left .qtklx {
  width: 100%;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #eef0f5;
  box-sizing: border-box;
  padding: 18px 20px;
  transition: box-shadow 0.25s;
}

.row_2 .left .qtklx:hover {
  box-shadow: 0 4px 18px rgba(100, 110, 255, 0.08);
}

.row_2 .left .title_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.row_2 .left .title_box .title {
  color: #1a1a2e;
  font-size: 18px;
  font-weight: 700;
  padding-left: 12px;
  border-left: 3px solid #646eff;
}

.jump_box {
  display: flex;
  align-items: center;
}

.sb_number {
  width: 180px;
}

.jump_box .start_btn {
  padding: 8px 22px !important;
  font-size: 14px;
  border-radius: 6px;
  background: linear-gradient(135deg, #646eff, #7b83ff) !important;
  color: #fff;
  box-shadow: 0 3px 10px rgba(100, 110, 255, 0.25);
  transition: all 0.25s;
  margin-left: 10px;
}

.jump_box .start_btn:hover {
  box-shadow: 0 5px 18px rgba(100, 110, 255, 0.4);
  transform: translateY(-1px);
}

.progress_box {
  width: 100%;
  margin-top: 16px;
  font-size: 14px;
}

.progress_box .text_box {
  display: flex;
  color: #646eff;
  justify-content: space-between;
  margin-bottom: 8px;
  font-weight: 500;
}

/* 快捷入口区 */
.row_2 .left .select_box {
  width: 100%;
  flex: 1;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #eef0f5;
  margin-top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 16px 42px;
  position: relative;
  transition: box-shadow 0.25s;
}

.row_2 .left .select_box:hover {
  box-shadow: 0 4px 18px rgba(100, 110, 255, 0.08);
}

.select_box .more_box {
  width: 16px;
  height: 24px;
  position: absolute;
  right: 16px;
  top: 16px;
}

.more_box .point_box {
  width: 16px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.select_box .more_box .more_list {
  width: 117px;
  height: 80px;
  position: absolute;
  right: 0;
  top: 24px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.1);
  border: 1px solid #ebeef5;
  box-sizing: border-box;
  transition: all 0.15s linear;
  overflow: hidden;
}

.more_list_close {
  height: 0 !important;
}

.more_item {
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s;
}

.more_item:hover {
  background: #eef0ff;
  color: #646eff;
}

.select_box .more_box .point {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #909399;
}

.select_box .wrong_collect_btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s;
}

.select_box .wrong_collect_btn:hover {
  transform: translateY(-2px);
}

.wrong_collect_btn img {
  width: 56px;
  height: 56px;
}

.wrong_collect_btn .text {
  font-size: 13px;
  margin-top: 8px;
  color: #606266;
}

/* --- 中间：章节练习 + 题型练习 --- */
.row_2 .middle {
  width: 272px;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
}

.row_2 .middle .zjlx {
  width: 272px;
  height: 158px;
  position: relative;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.25s;
}

.row_2 .middle .zjlx:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.zjlx img {
  width: 100%;
  height: 100%;
}

.zjlx .text1 {
  position: absolute;
  left: 16px;
  top: 16px;
  font-weight: 700;
  font-size: 18px;
  color: #1a1a2e;
}

.zjlx .text2 {
  color: #606266;
  font-size: 12px;
  position: absolute;
  left: 16px;
  top: 52px;
}

.zjlx .text3 {
  color: #fff;
  font-size: 14px;
  position: absolute;
  left: 16px;
  top: 120px;
  font-weight: 600;
  background: linear-gradient(135deg, #646eff, #7b83ff);
  padding: 4px 12px;
  border-radius: 4px;
}

.row_2 .middle .txlx {
  width: 272px;
  flex: 1;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #eef0f5;
  box-sizing: border-box;
  padding: 16px;
  transition: box-shadow 0.25s;
}

.row_2 .middle .txlx:hover {
  box-shadow: 0 4px 18px rgba(100, 110, 255, 0.08);
}

.txlx .title {
  color: #1a1a2e;
  font-weight: 700;
  font-size: 17px;
  padding-left: 12px;
  border-left: 3px solid #646eff;
}

.txlx .select_box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 8px;
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
}

.subject_type_btn {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.2s;
}

.subject_type_btn:hover {
  transform: translateY(-2px);
}

.subject_type_btn.disable {
  opacity: 0.3;
  cursor: not-allowed;
}

.subject_type_btn img {
  width: 48px;
  height: 48px;
}

.subject_type_btn .text {
  font-size: 13px;
  color: #606266;
  margin-top: 6px;
}

/* --- 右侧：数据分析 --- */
.row_2 .right {
  width: 272px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #eef0f5;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
  transition: box-shadow 0.25s;
}

.row_2 .right:hover {
  box-shadow: 0 4px 18px rgba(100, 110, 255, 0.08);
}

.row_2 .right .title {
  font-size: 17px;
  font-weight: 700;
  width: 100%;
  text-align: left;
  box-sizing: border-box;
  color: #1a1a2e;
  padding-left: 12px;
  border-left: 3px solid #646eff;
  margin-bottom: 8px;
}

.row_2 .right .data_box {
  width: 100%;
  flex: 1;
  box-sizing: border-box;
  padding: 20px 8px;
  display: flex;
  justify-content: space-between;
}

.row_2 .right .data_box > div {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.data_box .data_item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.data_box .data_item > div {
  position: relative;
}

.data_box .data_item img {
  width: 12px;
  height: 12px;
  position: absolute;
  right: -16px;
  top: 59%;
  transform: translate(0, -50%);
}

.data_box .data_item .text1 {
  color: #646eff;
  font-weight: 700;
  font-size: 22px;
}

.data_box .data_item .text2 {
  color: #909399;
  font-size: 12px;
}

.data_box .data_item .text3 {
  color: #a3aaba;
  font-size: 12px;
  margin-top: 10px;
}

/* ========== 第二行：实用工具 ========== */
.row_3 {
  width: 100%;
  background: #fff;
  margin-top: 16px;
  border-radius: 10px;
  border: 1px solid #eef0f5;
  box-sizing: border-box;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.25s;
}

.row_3:hover {
  box-shadow: 0 4px 18px rgba(100, 110, 255, 0.08);
}

.row_3 .title {
  width: 100%;
  font-weight: 700;
  font-size: 17px;
  color: #1a1a2e;
  padding-left: 12px;
  border-left: 3px solid #646eff;
}

.row_3 .tool_box {
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  margin-top: 16px;
  gap: 12px;
}

.tool_box .tool_item {
  flex: 1;
  height: 100%;
  min-height: 200px;
  border-radius: 8px;
}

.tool_box .tool_item:nth-of-type(1) {
  background: linear-gradient(135deg, #ecf5ff, #e0edff);
}

.tool_box .tool_item:nth-of-type(2) {
  background: linear-gradient(135deg, #ffedd3, #ffe4c4);
}

/* ========== 章节列表弹窗 ========== */
.shadeBox {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10;
  box-sizing: border-box;
  padding-top: 60px;
  backdrop-filter: blur(2px);
}

.zhangjie_box {
  width: 70%;
  height: 80%;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 52%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.zhangjie_box .title {
  width: 100%;
  height: 48px;
  background: linear-gradient(135deg, #646eff, #7b83ff);
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
  color: #fff;
  font-size: 17px;
  font-weight: 600;
}

.zhangjie_box .tree_box {
  width: 100%;
  flex: 1;
  box-sizing: border-box;
  padding: 16px 20px;
  overflow-y: auto;
}

.zhangjie_box img {
  width: 22px;
  height: 22px;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.zhangjie_box img:hover {
  opacity: 1;
}

/* 树节点样式 */
:deep(.el-tree-node__expand-icon) {
  color: #646eff;
  font-size: 18px;
}

:deep(.el-tree-node__content) {
  color: #1a1a2e;
  font-weight: 600;
  font-size: 15px;
  padding: 6px 0;
}

:deep(.el-tree > .el-tree-node) {
  border-bottom: 1px solid #f0f2f5;
  padding: 8px 0;
}

.tree_other_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tree_other_box .info_box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.tree_other_box .info_box .status_btn {
  color: #36c275;
  font-size: 13px;
  font-weight: 500;
  margin-right: 16px;
}

.tree_other_box .info_box .count_box {
  color: #909399;
  font-size: 13px;
  font-weight: 500;
}

.tree_other_box .info_box .start_btn {
  font-weight: 500;
  padding: 5px 12px;
  font-size: 12px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  background: linear-gradient(135deg, #646eff, #7b83ff);
  box-shadow: 0 2px 8px rgba(100, 110, 255, 0.2);
  transition: all 0.2s;
}

.tree_other_box .info_box .start_btn:hover {
  box-shadow: 0 3px 12px rgba(100, 110, 255, 0.3);
}

.start_btn img {
  width: 14px;
  height: 14px;
}
</style>
